import { Routes, Route } from 'react-router-dom'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { BackgroundPreloader } from './components/BackgroundPreloader'
import { CursorTrail } from './components/CursorTrail'
import { HomePage } from './pages/HomePage'
import { AboutPage } from './pages/AboutPage'
import { ServerInfoPage } from './pages/ServerInfoPage'
import { RegisterPage } from './pages/RegisterPage'
import { CreditsPage } from './pages/CreditsPage'
import { useDragScroll } from './hooks/useDragScroll'
import { FeatureRequestPage } from './pages/FeatureRequestPage'
import { TradingPage } from './pages/TradingPage'

function App() {
  // Enable click and drag scrolling
  useDragScroll()
  return (
    <div className="min-h-screen flex flex-col">
      <BackgroundPreloader />
      <CursorTrail />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/server-info" element={<ServerInfoPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/credits" element={<CreditsPage />} />
          {/* Feature Requests - 2025-01-XX */}
          <Route path="/feature-requests" element={<FeatureRequestPage />} />
          {/* Trading Page - 2025-01-XX */}
          <Route path="/trading" element={<TradingPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
